import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getSignalsInfo } from "../../redux/new-dashboard/dashboardSlice";

function UseFetchSignalInfo() {
  const {
    main: { userData },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    if (userData?.email) {
      dispatch(
        getSignalsInfo(userData?.["custom:custom_username"], userData?.email),
      );
    }
  }, [userData?.email]);

  return null;
}

export default UseFetchSignalInfo;
